<template>
  <div class="store">
    <cities-selector
      :current-region="currentRegion"
      @on-certain="onSelectorCertainClick"
      @on-nearStore="onSelectorNearClick"
    />
    <div class="store-wrapper">
      <!-- 粉丝群 -->
      <div
        class="store-item"
        v-if="liveFansGroup"
        @click="onStoreClick(liveFansGroup)"
      >
        <div>
          <div class="store-item-name">
            {{ liveFansGroup.display_name }}
          </div>
        </div>

        <div class="join-btn">立即入群</div>
      </div>

      <!-- 门店列表 -->
      <div
        :key="index"
        class="store-item"
        @click="onStoreClick(item)"
        v-for="(item, index) in storeList"
      >
        <div>
          <div class="store-item-name">
            {{ item.name }}
            <span class="distance" v-if="item.distance">
              {{ Math.round(item.distance * 10) / 10 }}KM
            </span>
            <span class="tag" v-if="item.distance && index == 0">离我最近</span>
          </div>
          <div class="store-item-adress">{{ item.address }}</div>
        </div>
        <div class="join-btn">立即入群</div>
      </div>
    </div>
  </div>
</template>

<script>
import handle from './_handle'
import share from '../../_mixins/share'
import { getBoutiqueByCity } from './_service'
import reverseGeocoder from '@/handler/map.geocoder'
import CitiesSelector from '@/component/cities-selector/index'
import handleWxConfig from '@/handler/wx.sdk.handler/wx.conf.handler'

export default {
  name: 'store_page',
  mixins: [share, handle],
  components: { CitiesSelector },

  data() {
    return {
      // 门店列表
      storeList: [],
      // 当前选择的城市
      currentRegion: {},
    }
  },

  mounted() {
    // 处理微信分享
    this.wxShare()

    // 获取置顶粉丝群列表
    this.getNearStoreList()
  },

  methods: {
    /**
     * 页面事件
     */
    // 点击门店
    onStoreClick(e) {
      this.$router.push({
        name: 'qrcode_page',
        query: {
          storeId: e.store_id,
          name: e.contact_way_name || '',
        },
      })
    },

    // 获取附近门店
    onSelectorNearClick() {
      this.getNearStoreList()
    },

    // 城市选择器确认
    onSelectorCertainClick(e) {
      e.city && this.getStoreList({ city: e.city })
    },

    // 默认对应的省市
    handelCurrentLocation(province, city) {
      this.currentRegion = {
        province: {
          name: province,
        },
        city: {
          name: city,
        },
      }
    },

    /**
     * 数据处理
     */
    // 获取门店列表
    getStoreList(params) {
      // 获取附近门店
      getBoutiqueByCity(params).then((data) => {
        // 门店地址为空
        if (!data.length) {
          this.$router.push({
            name: 'qrcode_page',
          })
        }
        this.storeList = data
      })
    },

    // 获取附近门店
    getNearStoreList() {
      handleWxConfig(['getLocation']).then(
        () => {
          // 获取用户地理位置
          this.$wx.getLocation({
            type: 'gcj02',
            success: (res) => {
              reverseGeocoder(res.latitude, res.longitude).then((data) => {
                this.getStoreList(data)
                this.handelCurrentLocation(data.province, data.city)
              })
            },
            fail: (err) => {
              this.getStoreList({ city: '上海' })
              this.handelCurrentLocation('上海市', '上海')
            },
            cancel: () => {
              this.getStoreList({ city: '上海' })
              this.handelCurrentLocation('上海市', '上海')
            },
          })
        },
        () => {
          this.getStoreList({ city: '上海' })
          this.handelCurrentLocation('上海市', '上海')
        }
      )
    },
  },
}
</script>

<style lang="less" scoped>
@import './store.less';
</style>
